export default __webpack_public_path__ + "static/ai-buildlabs-9208239ebb3d9a8203ff0f7dd0213c21.png";